import { action } from 'satcheljs';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';

export const setCalendarColorScheme = action(
    'COLOR_RESOLVER_SET_CALENDAR_COLORSCHEME',
    (calendarId: string, colorScheme: ColorScheme) => ({ calendarId, colorScheme })
);
